module.exports = __webpack_public_path__ + "catalog/items/puerven_62/6.2.jpg";